import { configureRefreshFetch as e, fetchJSON as t } from "refresh-fetch";
import * as n from "@sentry/react";
import r from "i18next";
import { IVStatus as i, LocalStorage as a, MemoryStorage as o, ORIGINS as s, getPhoneNumberString as c, isBlobInstance as l } from "@chekin/core";
//#region \0rolldown/runtime.js
var u = Object.create, d = Object.defineProperty, ee = Object.getOwnPropertyDescriptor, f = Object.getOwnPropertyNames, p = Object.getPrototypeOf, m = Object.prototype.hasOwnProperty, te = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ne = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = f(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !m.call(e, s) && s !== n && d(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ee(t, s)) || r.enumerable
	});
	return e;
}, re = (e, t, n) => (n = e == null ? {} : u(p(e)), ne(t || !e || !e.__esModule || !m.call(e, "default") ? d(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), h = class e {
	static #e = this.instance = null;
	static getDecryptionManager() {
		return e.instance;
	}
	static setDecryptionManager(t) {
		e.instance = t;
	}
	static clearDecryptionManager() {
		e.instance = null;
	}
	static isDecryptionEnabled() {
		return e.instance?.isEnabled() ?? !1;
	}
}, g = class {
	static #e = this.initParams = { apikey: "" };
	static #t = this._isSDK = !0;
	static get isSDK() {
		return this._isSDK;
	}
	static setIsSDK(e) {
		this._isSDK = e;
	}
	static setInitParams(e) {
		this.initParams = e;
	}
	static setJwtToken(e) {
		let t = h.getDecryptionManager();
		t && t.setJwtToken(e);
	}
}, _ = class e {
	static checkEmptyArray(e) {
		return !e || !Array.isArray(e);
	}
	static getSpanishCitiesAsOptions(t) {
		let n = t?.results;
		return e.checkEmptyArray(n) ? [] : n.map((e) => ({
			label: e.name,
			value: e.code
		}));
	}
	static getCountriesAsOptions(t) {
		let n = t?.results;
		return e.checkEmptyArray(n) ? [] : n?.map((e) => ({
			label: e?.country?.name,
			value: e?.country?.code,
			data: e
		}));
	}
	static getProvincesAsOptions(t) {
		let n = t?.results;
		return e.checkEmptyArray(n) ? [] : n?.map((e) => ({
			label: e?.division_level_2?.name,
			value: e?.division_level_2?.code
		}));
	}
	static getCitiesAsOptions(t) {
		let n = t?.results;
		return e.checkEmptyArray(n) ? [] : n?.map((e) => ({
			value: e?.division_level_3?.code,
			label: e?.division_level_3?.name
		}));
	}
	static getDistrictsAsOptions(t) {
		let n = t?.results;
		return e.checkEmptyArray(n) ? [] : n?.map((e) => ({
			label: e?.division_level_1?.name,
			value: e?.division_level_1?.code
		}));
	}
}, v = { decryptionError: 1111 }, y = class extends Error {
	constructor(e, t, n) {
		super(e), this.name = "CustomError", this.code = t, this.details = n, this.timestamp = /* @__PURE__ */ new Date(), Error.captureStackTrace(this, this.constructor);
	}
}, ie = async (e, t) => {
	let i = h.getDecryptionManager(), a = null;
	if (i?.isEnabled() && t?.requireEncryption) {
		a = await i.getDecryptionKey();
		let e = i.getEncryptionHeaders();
		Object.keys(e).length > 0 && (t.headers ? Object.entries(e).forEach(([e, n]) => {
			t.headers.set(e, n);
		}) : t.headers = new Headers(e));
	}
	return new Promise((o, s) => fetch(e, t).then(async (e) => {
		let t = await ae(e);
		if (i?.isEnabled() && i.isResponseEncrypted(e) && a) try {
			t = await i.decryptResponse(t, a);
		} catch (e) {
			throw console.error("Failed to decrypt response:", e), n.captureMessage("Failed to decrypt response"), new y(r.t("something_went_wrong"), v.decryptionError);
		}
		return ce({
			response: e,
			body: t
		});
	}).then(o).catch(s));
}, ae = (e) => {
	let t = e.headers.get("content-type");
	return t && t.indexOf("json") >= 0 ? e.clone().text().then(oe) : e.clone().text();
}, oe = (e) => {
	if (!e) return null;
	try {
		return JSON.parse(e);
	} catch {
		throw Error(`Failed to parse unexpected JSON response: ${e}`);
	}
}, se = class extends Error {
	constructor(e, t, n) {
		super(), this.name = "ResponseError", this.status = e, this.response = t, this.body = n;
	}
}, ce = ({ response: e, body: t }) => {
	if (e.ok) return {
		response: e,
		body: t
	};
	throw new se(e.status, e, t);
}, b = "chekin-token", le = "guest-token", x = "i18nextLng", ue = 2, de = {
	multiPaymentUpdated: "MULTI_PAYMENT_UPDATED",
	ivStartedOnMobile: "IV_STARTED_ON_MOBILE",
	ivCompletedReturningToDesktop: "IV_COMPLETED_RETURNING_TO_DESKTOP",
	ivCompletedContinuedOnMobile: "IV_COMPLETED_CONTINUE_ON_MOBILE",
	airaloPaymentsCreated: "AIRALO_PAYMENTS_CREATED"
}, fe = class {
	static getToken() {
		if (g.isSDK) return o.get(this.key);
		try {
			return a.get(this.key) ?? null;
		} catch (e) {
			return console.error(e), null;
		}
	}
	static persistToken(e = "") {
		g.isSDK ? o.set(this.key, e) : a.set(this.key, e);
	}
	static removeToken() {
		g.isSDK ? o.remove(this.key) : a.remove(this.key);
	}
	static hasToken() {
		return !!this.getToken();
	}
}, S = class extends fe {
	static #e = this.key = b;
}, C = class extends fe {
	static #e = this.key = le;
}, w = {
	refresh: () => "api/v3/checkin-online-token/refresh/",
	apikeyAuth: () => "sdk/api/v1/apikey-auth",
	shortLink: (e) => `api/short-link/${e}/`,
	usersCheckEmail: () => "api/v1/guest-accounts/users/check-email/",
	usersInitiate: () => "api/v1/guest-accounts/users/initiate/",
	usersFinalize: () => "api/v1/guest-accounts/users/finalize/",
	guestToken: () => "api/v1/guest-accounts/token/",
	refreshGuestToken: () => "api/v1/guest-accounts/token/renew/",
	me: () => "api/v1/guest-accounts/users/me/",
	googleCallback: () => "api/v1/guest-accounts/oauth/google/callback/",
	participants: (e = "") => `api/v1/guest-accounts/participants/${e ? `?id=${e}` : ""}`
}, pe = (e, t, n) => {
	let r = g.initParams?.apikey, i = new Headers(e || { "Content-Type": "application/json" });
	if (i.set("embedded-sdk-app", r), i.set("X-source", s.embeddedGuestApp), t) return i.has("Content-Type") || i.set("Content-Type", "application/json"), i;
	let c = C.getToken();
	c && n && !n.includes("/documents/") && !n.includes("/upselling/") && i.set("X-Guest-Token", `JWT ${c}`);
	let l = o.get(b), u = a.get(x)?.slice(0, 2);
	return u && i.set("Accept-Language", u), l && i.set("Authorization", `JWT ${l}`), i;
}, me = (e, t, n) => {
	let r = new Headers(e || { "Content-Type": "application/json" }), i = n?.includes("v1/guest-accounts"), o = C.getToken(), c = i && !t && o;
	if (r.set("X-source", s.guestAppV2), t) return r.has("Content-Type") || r.set("Content-Type", "application/json"), r;
	o && n && !n.includes("/documents/") && !n.includes("/upselling/") && r.set("X-Guest-Token", `JWT ${o}`);
	let l = c ? o : S.getToken(), u = a.get(x)?.slice(0, 2);
	return u && r.set("Accept-Language", u), l && r.set("Authorization", `JWT ${l}`), r;
}, T = (e, t, n) => g.isSDK ? pe(e, t, n) : me(e, t, n), E = "https://api-ng.chekintest.xyz", he = [
	400,
	401,
	403
], ge = [
	"Failed to fetch",
	"Load failed",
	"NetworkError"
], _e = "ERR_INTERNET_DISCONNECTED", ve = [
	500,
	502,
	503,
	504,
	400
], ye = [v.decryptionError];
//#endregion
//#region src/api/apiClient/utils.ts
function D(e = "") {
	return `${E}/${e}`;
}
var be = "No internet connection";
function O(e) {
	if (!e) return !1;
	let t = e.toLowerCase();
	return ge.some((e) => t.includes(e.toLowerCase()));
}
function xe(e, t, n) {
	let i = e?.status;
	return O(n) ? {
		message: r.t("no_internet_connection") || be,
		status: 1001,
		body: t,
		name: _e
	} : e ? e && he.includes(e.status) ? t ? {
		...t,
		business_status: t.status,
		status: i
	} : {
		status: i,
		body: t
	} : (e?.status, e?.status === 404 ? {
		message: "404 Not found. Please contact support.",
		status: i,
		body: t
	} : e?.status === 405 ? {
		message: "405 Method not allowed. Please contact support.",
		status: i,
		body: t
	} : e?.status === 429 ? {
		message: r.t("too_many_requests"),
		status: i,
		body: t
	} : e?.status === 500 ? {
		message: "500 Internal Server error. Please contact support.",
		status: i,
		body: t
	} : e?.status === 502 ? {
		message: "502 Bad Gateway. Please contact support.",
		status: i,
		body: t
	} : e?.status === 503 ? {
		message: "503 Service Unavailable. Please contact support.",
		status: i,
		body: t
	} : e?.status === 504 ? {
		message: "504 Gateway Timeout. Please contact support.",
		status: i,
		body: t
	} : null) : null;
}
function Se(e) {
	return Math.min(1e3 * 2 ** e, 3e4);
}
function Ce(e) {
	return new Promise((t) => {
		setTimeout(t, e);
	});
}
var we = (e) => "response" in e, Te = (e) => "message" in e;
function Ee({ retryCount: e = 0, errorRetryLimit: t }, n) {
	let r = g.initParams?.maxRequestsRetriesCount, i = Te(n) && O(n.message), a = n instanceof y, o = we(n) && ve.includes(n?.response?.status);
	return (i || o || a) && e < (t ?? r ?? (i ? 2 : 0));
}
//#endregion
//#region src/utils/apiKeyAuthPayload.ts
function De(e) {
	return {
		apikey: e.apikey,
		resource_id: e.resourceId,
		external_resource_id: e.externalResourceId,
		resource_type: e.resourceType,
		...e.embedOrigin && {
			embed_origin: e.embedOrigin,
			embed_origin_source: e.embedOriginSource,
			embed_ancestors: e.embedAncestors
		},
		...e.sdk && {
			sdk: e.sdk,
			sdk_version: e.sdkVersion,
			page_path: e.pagePath
		}
	};
}
//#endregion
//#region src/api/refreshFetch/refreshFetch.ts
var Oe = (e, { publicAccess: t, headers: n, ...r } = {}) => {
	let i = T(n, t, e);
	return ie(e, {
		...r,
		headers: i
	});
}, ke = (e) => O(e.message) ? !0 : e.response && e.response.status === 401, Ae = async () => {
	let e = JSON.stringify(De(g.initParams));
	return (await t(D(w.apikeyAuth()), {
		method: "POST",
		headers: T(null, !0),
		body: e
	})).body?.access_token;
}, je = async () => {
	let e = S.getToken();
	if (!e) return null;
	let n = JSON.stringify({ token: e });
	return (await t(D(w.refresh()), {
		body: n,
		method: "POST"
	})).body?.token;
}, Me = async () => {
	let e = C.getToken();
	if (!e) return null;
	let n = JSON.stringify({ access_token: e });
	return (await t(D(w.refreshGuestToken()), {
		body: n,
		method: "POST"
	})).body?.access_token;
}, Ne = e({
	shouldRefreshToken: ke,
	refreshToken: async () => {
		let e = g.isSDK;
		try {
			let t = e ? await Ae() : await je();
			t && (g.setJwtToken(t), S.persistToken(t));
		} catch {
			S.removeToken();
		}
		try {
			let e = await Me();
			e && C.persistToken(e);
		} catch (e) {
			e?.body?.detail !== "Token is not expired yet" && C.removeToken();
		}
	},
	fetch: Oe
});
//#endregion
//#region src/api/apiClient/apiClient.ts
async function k(e, t = {}) {
	let { externalURL: n, retryCount: r = 0 } = t;
	try {
		let { response: r, body: i } = await Ne(n || D(e), t);
		return {
			body: i,
			headers: r.headers,
			response: r
		};
	} catch (n) {
		if ((we(n) || Te(n)) && Ee(t, n)) return await Ce(Se(r)), k(e, {
			...t,
			retryCount: r + 1
		});
		throw xe(n.response, n.body, n?.message) || (n.body ?? (n instanceof y ? n : Error(n?.message || "An unknown error occurred")));
	}
}
var A = {
	get: (e, t) => k(e, {
		method: "GET",
		...t
	}),
	post: (e, { body: t, json: n, ...r } = {}) => k(e, {
		method: "POST",
		body: n ? JSON.stringify(n) : t,
		...r
	}),
	put: (e, { body: t, json: n, ...r } = {}) => k(e, {
		method: "PUT",
		body: n ? JSON.stringify(n) : t,
		...r
	}),
	patch: (e, { body: t, json: n, ...r } = {}) => k(e, {
		method: "PATCH",
		body: n ? JSON.stringify(n) : t,
		...r
	}),
	delete: (e, { body: t, ...n } = {}) => k(e, {
		method: "DELETE",
		...n
	})
}, j = class e {
	static #e = this.ENDPOINTS = w;
	async getAuthToken(t, n) {
		return (await A.post(e.ENDPOINTS.apikeyAuth(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
	getChekinToken({ token: t }, n) {
		return A.get(e.ENDPOINTS.shortLink(t), {
			publicAccess: !0,
			...n
		});
	}
	async checkEmail(t, n) {
		return (await A.post(e.ENDPOINTS.usersCheckEmail(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
	async initiateUser(t, n) {
		return (await A.post(e.ENDPOINTS.usersInitiate(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
	async finalizeUser(t, n) {
		return (await A.post(e.ENDPOINTS.usersFinalize(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
	async getToken(t, n) {
		return (await A.post(e.ENDPOINTS.guestToken(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
	async getMe(t) {
		return (await A.get(e.ENDPOINTS.me(), t)).body;
	}
	async getParticipants(t) {
		return (await A.get(e.ENDPOINTS.participants(), t)).body;
	}
	async oauthGoogleCallback(t, n) {
		return (await A.post(e.ENDPOINTS.googleCallback(), {
			json: t,
			publicAccess: !0,
			...n
		})).body;
	}
}, M = class {
	constructor() {
		this.ENDPOINTS = {
			travelGuide: (e) => `api/v1/ai-service/agents/travel-guides/reservation/${e}`,
			generateGuide: () => "api/v1/ai-service/agents/travel-guides/runs",
			getGuideRun: (e) => `api/v1/ai-service/agents/travel-guides/runs/${e}`,
			getTravelGuideThumbnail: (e) => `api/v1/ai-service/agents/travel-guides/thumbnail/${e}`,
			retryGuide: (e) => `api/v1/ai-service/agents/travel-guides/reservation/${e}/retry`,
			dismissSlot: (e, t) => `api/v1/ai-service/agents/travel-guides/reservation/${e}/slots/${t}/dismiss`
		};
	}
	async getGuide(e, t) {
		return (await A.get(this.ENDPOINTS.travelGuide(e), t)).body;
	}
	async generateGuide(e, t) {
		return (await A.post(this.ENDPOINTS.generateGuide(), {
			json: e,
			...t
		})).body;
	}
	async retryGuide(e, t) {
		return (await A.post(this.ENDPOINTS.retryGuide(e), t)).body;
	}
	async getGuideRun(e, t) {
		return (await A.get(this.ENDPOINTS.getGuideRun(e), t)).body;
	}
	async getTravelGuideThumbnail(e, t) {
		return (await A.get(this.ENDPOINTS.getTravelGuideThumbnail(e), t)).body;
	}
	async dismissSlot(e, t, n) {
		return (await A.post(this.ENDPOINTS.dismissSlot(e, t), n)).body;
	}
}, N = ({ regular: e, sdk: t }) => g.isSDK ? t : e, P = class {
	constructor() {
		this.ENDPOINTS = {
			oneV4: (e, t = "") => N({
				regular: `api/v4/guestapp/guests/${e}/${t}`,
				sdk: `sdk/api/v1/guestapp/guests/${e}/${t}`
			}),
			getSchema: () => N({
				regular: "api/v4/guestapp/guests/schema/v2",
				sdk: "sdk/api/v1/guestapp/guests/schema/v2"
			}),
			getDocumentChoices: () => N({
				regular: "api/v4/guestapp/guests/document-choices/",
				sdk: "sdk/api/v1/guestapp/guests/document-choices/"
			}),
			delete: (e) => N({
				regular: `api/v3/guests/${e}/`,
				sdk: `sdk/api/v1/guests/${e}/`
			}),
			create: (e = "") => N({
				regular: `api/v4/guestapp/guests/${e}`,
				sdk: `sdk/api/v1/guestapp/guests/${e}`
			}),
			update: (e) => N({
				regular: `api/v4/guestapp/guests/${e}/`,
				sdk: `sdk/api/v1/guestapp/guests/${e}/`
			}),
			livenessDetection: () => N({
				regular: "api/v4/guest-liveness-detection/",
				sdk: "sdk/api/v2/guest-liveness-detection/"
			}),
			uploadLivenessVideo: () => N({
				regular: "api/v4/guest-liveness-detection/upload/",
				sdk: "sdk/api/v2/guest-liveness-detection/upload/"
			}),
			searchForIV: () => "api/v3/guests-iv/search-guest",
			createGuestByParticipant: () => N({
				regular: "api/v4/guestapp/guests/create-from-participant/",
				sdk: "sdk/api/v1/guestapp/guests/create-from-participant/"
			})
		};
	}
	async getOne(e, t) {
		return (await A.get(this.ENDPOINTS.oneV4(e), {
			requireEncryption: !0,
			...t
		})).body;
	}
	async create(e, t) {
		return (await A.post(this.ENDPOINTS.create(), {
			body: e,
			headers: {},
			...t
		})).body;
	}
	async createGuestByParticipant(e, t) {
		return (await A.post(this.ENDPOINTS.createGuestByParticipant(), {
			json: e,
			...t
		})).body;
	}
	async createMin(e, t) {
		return (await A.post(this.ENDPOINTS.create("?min=true"), {
			json: e,
			...t
		})).body;
	}
	async patch(e, t, n) {
		return (await A.patch(this.ENDPOINTS.update(e), {
			body: t,
			headers: {},
			...n
		})).body;
	}
	async put(e, t, n) {
		return (await A.put(this.ENDPOINTS.update(e), {
			body: t,
			headers: {},
			...n
		})).body;
	}
	async delete(e, t) {
		return (await A.delete(this.ENDPOINTS.delete(e), t)).body;
	}
	async getSchema(e, t) {
		return (await A.post(this.ENDPOINTS.getSchema(), {
			json: e,
			...t
		})).body;
	}
	async getDocumentChoices(e, t) {
		return (await A.post(this.ENDPOINTS.getDocumentChoices(), {
			json: e,
			...t
		})).body;
	}
	transformLivenessVideoPayloadToFormData(e) {
		let t = new FormData();
		return t.append("file", e, "liveness-video.mp4"), t;
	}
	async uploadLivenessVideo(e, t) {
		return (await A.post(this.ENDPOINTS.uploadLivenessVideo(), {
			body: this.transformLivenessVideoPayloadToFormData(e),
			headers: {},
			...t
		})).body;
	}
	async livenessDetection(e, t) {
		return (await A.post(this.ENDPOINTS.livenessDetection(), {
			json: e,
			...t
		})).body;
	}
	async searchForIV(e, t) {
		let n = new URLSearchParams({
			housing_id: e.housing_id,
			name: e.name,
			surname: e.surname,
			...e.id_number && { id_number: e.id_number },
			...e.date_of_birth && { date_of_birth: e.date_of_birth },
			...e.checkout_date && { checkout_date: e.checkout_date }
		}).toString();
		return (await A.get(`${this.ENDPOINTS.searchForIV()}?${n}`, t)).body;
	}
}, F = class {
	constructor() {
		this.ENDPOINTS = { phoneNumber: () => "api/v3/validators/phone-number" };
	}
	async validatePhoneNumber(e, t) {
		return (await A.post(this.ENDPOINTS.phoneNumber(), {
			json: e,
			...t
		})).body;
	}
}, I = (e) => new URLSearchParams(Object.entries(e).filter((e) => {
	let [, t] = e;
	return t !== void 0 && t !== "";
})).toString(), L = class {
	constructor() {
		this.ENDPOINTS = {
			create: () => N({
				regular: "api/v3/reservations/",
				sdk: "sdk/api/v1/reservations/"
			}),
			getOne: (e = "") => N({
				regular: `api/v4/reservations/${e}/`,
				sdk: `sdk/api/v2/reservations/${e}/?is_housing_deactivated=true`
			}),
			getOneV3: (e = "") => N({
				regular: `api/v3/reservations/${e}/`,
				sdk: `sdk/api/v1/reservations/${e}/`
			}),
			getByExternalId: (e = "") => N({
				regular: `api/v4/reservations/get-with-external-id/?external_id=${encodeURIComponent(e)}`,
				sdk: `sdk/api/v2/reservations/get-with-external-id/?external_id=${encodeURIComponent(e)}&is_housing_deactivated=true`
			}),
			getSummary: (e = "") => N({
				regular: `api/v4/guestapp/reservations/${e}/summary/`,
				sdk: `sdk/api/v1/guestapp/reservations/${e}/summary/`
			}),
			directReservation: "api/v4/reservations/direct-reservation",
			reservationSearch: (e = "") => N({
				regular: `api/v4/reservation-search/?${e}`,
				sdk: `sdk/api/v2/reservation-search/?${e}`
			})
		};
	}
	async getOne({ id: e, externalId: t }, n) {
		let r = t ? this.ENDPOINTS.getByExternalId(t) : this.ENDPOINTS.getOne(e);
		return (await A.get(r, {
			requireEncryption: !0,
			...n
		})).body;
	}
	async getSummary(e, t) {
		return (await A.get(this.ENDPOINTS.getSummary(e), t)).body;
	}
	async findReservation(e, t) {
		return (await A.get(this.ENDPOINTS.reservationSearch(I(e)), t)).body;
	}
	async searchReservationByGuestName(e, t) {
		return (await A.get(this.ENDPOINTS.reservationSearch(I(e)), t)).body;
	}
	async getOrCreateDirectReservation(e, t) {
		return (await A.post(this.ENDPOINTS.directReservation, {
			json: e,
			...t
		})).body;
	}
	async createReservation(e, t) {
		return (await A.post(this.ENDPOINTS.create(), {
			json: e,
			...t
		})).body;
	}
	async updateReservation(e, t, n) {
		return (await A.patch(this.ENDPOINTS.getOneV3(e), {
			json: t,
			...n
		})).body;
	}
}, R = class {
	constructor() {
		this.ENDPOINTS = {
			search: (e = "") => `api/v4/locations-search/?${e}`,
			getByHousingId: (e = "") => `api/v4/locations/${e}/`,
			spanishResidenceCities: (e = "") => `api/v3/es-municipalities-names/?${e}`
		};
	}
	async fetchAllCountries(e) {
		return (await A.get(this.ENDPOINTS.search("phone_code=1&no_pagination=true"), e)).body;
	}
	async getByHousingId(e = "", t) {
		return (await A.get(this.ENDPOINTS.getByHousingId(e), t)).body;
	}
	async fetchPaginatedLocationsList(e = "") {
		return (await A.get(this.ENDPOINTS.search(e))).body;
	}
	fetchCountriesList({ page: e, searchQuery: t = "" }) {
		return this.fetchPaginatedLocationsList(`phone_code=1&page=${e}&q=${encodeURIComponent(t)}`);
	}
	fetchProvincesList({ page: e, searchQuery: t = "", countryCode: n }) {
		return this.fetchPaginatedLocationsList(`country=${n}&page=${e}&q=${encodeURIComponent(t)}`);
	}
	fetchCitiesList({ page: e, searchQuery: t = "", countryCode: n }) {
		return this.fetchPaginatedLocationsList(`country=${n}&division_level=3&page=${e}&q=${encodeURIComponent(t)}`);
	}
	fetchDistrictsList({ page: e, searchQuery: t = "", countryCode: n }) {
		return this.fetchPaginatedLocationsList(`country=${n}&division_level=1&page=${e}&q=${encodeURIComponent(t)}`);
	}
	fetchMunicipalitiesList({ page: e, searchQuery: t = "", countryCode: n, district: r }) {
		return this.fetchPaginatedLocationsList(`country=${n}&division_level=2&department=${r}&page=${e}&q=${encodeURIComponent(t)}`);
	}
	async fetchSpanishResidenceCitiesList({ page: e = 1, searchQuery: t = "" }, n) {
		return (await A.get(this.ENDPOINTS.spanishResidenceCities(`page=${e}&q=${encodeURIComponent(t)}`), n)).body;
	}
	async fetchLocationsByExternalUrl({ url: e, page: t = 1, searchQuery: n = "" }, r) {
		let i = new URL(e);
		return i.searchParams.set("page", t.toString()), i.searchParams.set("q", encodeURIComponent(n)), (await A.get("", {
			...r,
			externalURL: i.href
		})).body;
	}
}, z = class {
	constructor() {
		this.ENDPOINTS = {
			biomatchIdentification: (e = "") => `api/v4/biomatch/identification/${e ? `${e}/` : ""}`,
			biomatchIdentificationDeletePicture: (e) => `api/v4/biomatch/identification/${e}/delete-picture/`,
			biomatchPerson: (e = "") => `api/v4/biomatch/person/${e ? `${e}/` : ""}`,
			biomatchCompare: (e = "") => `api/v4/biomatch/compare/${e ? `${e}/` : ""}`,
			ocrPicture: () => "api/v3/ocr/picture/",
			ocrData: (e = "") => `api/v3/ocr/data/${e ? `${e}/` : ""}`,
			ivIntent: (e = "") => `api/v3/ocr/iv-intent/${e ? `${e}/` : ""}`,
			startIVOnMobile: () => "api/v3/ocr/process-iv-by-qr/start-iv-on-mobile",
			finishIVByQr: () => "api/v3/ocr/process-iv-by-qr/finish-iv-by-qr",
			schemaIVSDK: () => N({
				regular: "api/v4/guestapp/guests/schema-iv-sdk/",
				sdk: "sdk/api/v1/guestapp/guests/schema-iv-sdk/"
			})
		}, this.sendDocumentForFaceDetection = async (e, t) => (await A.post(this.ENDPOINTS.biomatchIdentification(), {
			json: e,
			...t
		})).body, this.checkDocumentFaceDetectionStatus = async (e, t) => (await A.get(this.ENDPOINTS.biomatchIdentification(e), t)).body, this.deleteDocumentPicture = async (e, t) => {
			await A.post(this.ENDPOINTS.biomatchIdentificationDeletePicture(e), { ...t });
		}, this.sendSelfieForFaceDetection = async (e, t) => (await A.post(this.ENDPOINTS.biomatchPerson(), {
			json: e,
			...t
		})).body, this.checkSelfieFaceDetection = async (e, t) => (await A.get(this.ENDPOINTS.biomatchPerson(e), t)).body, this.compareSelfieAndDocumentFaces = async (e, t) => (await A.post(this.ENDPOINTS.biomatchCompare(), {
			json: e,
			...t
		})).body, this.checkSelfieAndDocumentFacesComparingStatus = async (e = "", t) => (await A.get(this.ENDPOINTS.biomatchCompare(e), t)).body, this.sendImageForOCR = async (e, t) => (await A.post(this.ENDPOINTS.ocrPicture(), {
			json: e,
			...t
		})).body, this.checkImageOCRStatus = async (e = "", t) => (await A.get(this.ENDPOINTS.ocrData(e), t)).body, this.createIvIntent = async (e, t) => (await A.post(this.ENDPOINTS.ivIntent(), {
			json: e,
			...t
		})).body, this.updateIvIntent = async (e, t) => (await A.patch(this.ENDPOINTS.ivIntent(e.id), {
			json: e,
			...t
		})).body, this.getIvIntent = async (e, t) => (await A.get(this.ENDPOINTS.ivIntent(e), t)).body, this.startIVOnMobile = async (e, t) => (await A.post(this.ENDPOINTS.startIVOnMobile(), {
			json: { iv_intent_id: e },
			...t
		})).body, this.finishIVByQr = async (e, t) => (await A.post(this.ENDPOINTS.finishIVByQr(), {
			json: e,
			...t
		})).body, this.getIVSDKSchema = async (e, t) => (await A.post(this.ENDPOINTS.schemaIVSDK(), {
			json: e,
			...t
		})).body;
	}
}, B = class {
	constructor() {
		this.ENDPOINTS = {
			allExemptions: (e = "") => `api/v3/stat-tax-exemptions/?${e}`,
			season: (e) => N({
				regular: `api/v3/seasons/${e}/`,
				sdk: `sdk/api/v1/seasons/${e}/`
			}),
			seasonGuests: (e = "") => N({
				regular: `api/v3/season-guests/?${e}`,
				sdk: `sdk/api/v1/season-guests/?${e}`
			}),
			guestTaxes: (e = "", t = "") => N({
				regular: `api/v3/season-guests/${e}/?${t}`,
				sdk: `sdk/api/v1/season-guests/${e}/?${t}`
			}),
			initGuestTaxes: () => N({
				regular: "api/v3/season-guests/init/",
				sdk: "sdk/api/v1/season-guests/init/"
			})
		};
	}
	async getAllExemptions(e = "", t) {
		return (await A.get(this.ENDPOINTS.allExemptions(e), t)).body;
	}
	async getSeason(e, t) {
		return (await A.get(this.ENDPOINTS.season(e), t)).body;
	}
	async getSeasonGuests(e = "", t) {
		return (await A.get(this.ENDPOINTS.seasonGuests(e), t)).body;
	}
	async initGuestTaxes(e, t) {
		return (await A.post(this.ENDPOINTS.initGuestTaxes(), {
			json: e,
			...t
		})).body;
	}
	async calculateGuestTax({ id: e, ...t }, n, r) {
		return e ? (await A.patch(this.ENDPOINTS.guestTaxes(e, n), {
			json: t,
			...r
		})).body : (await A.post(this.ENDPOINTS.seasonGuests(n), {
			json: t,
			...r
		})).body;
	}
}, V = class {
	constructor() {
		this.ENDPOINTS = { getPurposeOfStay: (e = "") => N({
			regular: `api/v3/purposes-of-stay/?${e}`,
			sdk: `sdk/api/v1/purposes-of-stay/?${e}`
		}) };
	}
	async getPurposeOfStay(e) {
		return (await A.get(this.ENDPOINTS.getPurposeOfStay(), e)).body;
	}
}, H = class {
	constructor() {
		this.ENDPOINTS = {
			getOne: (e = "") => N({
				regular: `api/v4/housings/${e}/`,
				sdk: `sdk/api/v2/housings/${e}/`
			}),
			checkoutSetting: (e = "") => `api/v3/housing-check-out-settings/${e}`,
			reservationSearchHousings: (e = "") => `api/v4/reservation-search-housings/?${e}`
		};
	}
	async getOne(e, t) {
		return (await A.get(this.ENDPOINTS.getOne(e), t)).body;
	}
	async getCheckoutSetting(e, t) {
		return (await A.get(this.ENDPOINTS.checkoutSetting(e), t)).body;
	}
	async getReservationSearchHousings({ page: e, searchQuery: t }, n) {
		let r = new URLSearchParams({ page: String(e) });
		return t && r.set("name", t), (await A.get(this.ENDPOINTS.reservationSearchHousings(r.toString()), n)).body;
	}
	async getLocation(e) {
		return (await A.get("", e)).body;
	}
}, U = class {
	constructor() {
		this.ENDPOINTS = {
			contracts: (e = "") => `api/v3/documents/contracts/?${e}`,
			documentsPrivacyPolicy: (e) => `api/v3/documents/privacy-policy-settings/${e}/`
		};
	}
	async getContracts(e = "", t) {
		return (await A.get(this.ENDPOINTS.contracts(e), t)).body;
	}
	async getPrivacyPolicy(e, t) {
		return (await A.get(this.ENDPOINTS.documentsPrivacyPolicy(e), t)).body;
	}
}, W = class {
	constructor() {
		this.ENDPOINTS = { guestGroup: (e = "") => N({
			regular: `api/v4/guestapp/guest-group/${e}/`,
			sdk: `sdk/api/v1/guestapp/guest-group/${e}/`
		}) };
	}
	async getGuestGroup(e, t) {
		return (await A.get(this.ENDPOINTS.guestGroup(e), {
			requireEncryption: !0,
			...t
		})).body;
	}
	async patchGuestGroup(e, t, n) {
		return (await A.patch(this.ENDPOINTS.guestGroup(e), {
			json: t,
			...n
		})).body;
	}
}, G = class {
	constructor() {
		this.ENDPOINTS = {
			paymentsSettings: (e = "") => N({
				regular: `api/v3/payments-settings/?${e}`,
				sdk: `sdk/api/v1/payments-settings/?${e}`
			}),
			checkExpiredReservationPayments: () => N({
				regular: "api/v3/reservation-payments/check-expired/",
				sdk: "sdk/api/v1/reservation-payments/check-expired/"
			}),
			multiPayments: () => N({
				regular: "api/v4/multi-payments/",
				sdk: "sdk/api/v2/multi-payments/"
			}),
			oneMultiPayment: (e) => N({
				regular: `api/v4/multi-payments/${e}/`,
				sdk: `sdk/api/v2/multi-payments/${e}/`
			}),
			addon: (e) => N({
				regular: `api/v4/multi-payments/${e}/addon/`,
				sdk: `sdk/api/v2/multi-payments/${e}/addon/`
			}),
			paymentsCart: (e = "") => N({
				regular: `api/v4/payments-cart/?${e}`,
				sdk: `sdk/api/v2/payments-cart/?${e}`
			}),
			orderHistory: (e = "") => N({
				regular: `api/v4/order-history/?${e}`,
				sdk: `sdk/api/v2/order-history/?${e}`
			}),
			reservationPayments: (e = "") => `api/v3/reservation-payments/?reservation=${e}`
		}, this.checkExpiredReservationPayments = async (e, t) => (await A.post(this.ENDPOINTS.checkExpiredReservationPayments(), {
			json: e,
			...t
		})).body, this.getMultiPayment = async (e, t) => (await A.get(this.ENDPOINTS.oneMultiPayment(e), t)).body;
	}
	async getPaymentsSettings(e = "", t) {
		return (await A.get(this.ENDPOINTS.paymentsSettings(e), t)).body;
	}
	async createMultiPayment(e, t) {
		return (await A.post(this.ENDPOINTS.multiPayments(), {
			json: e,
			...t
		})).body;
	}
	async getPaymentsCart(e, t) {
		return (await A.get(this.ENDPOINTS.paymentsCart(e), t)).body;
	}
	async getOrderHistory(e, t) {
		return (await A.get(this.ENDPOINTS.orderHistory(e), t)).body;
	}
	async getReservationPayments(e, t) {
		return (await A.get(this.ENDPOINTS.reservationPayments(e), t)).body;
	}
	async getAddonMultiPayment(e, t) {
		return (await A.get(this.ENDPOINTS.addon(e), t)).body;
	}
}, Pe = /<\/?(?:p|div|br|hr|li|ul|ol|dl|dt|dd|h[1-6]|tr|td|th|table|thead|tbody|section|article|header|footer|aside|nav|blockquote|pre|figure|figcaption|form|fieldset)\b[^>]*>/gi, Fe = /<(script|style)\b[^>]{0,2000}>[\s\S]{0,20000}?<\/\1\s{0,20}>/gi, Ie = /<[^<>]{0,2000}>/g, K = 8e3, Le = {
	amp: "&",
	lt: "<",
	gt: ">",
	quot: "\"",
	apos: "'",
	nbsp: " ",
	ndash: "–",
	mdash: "—",
	hellip: "…",
	laquo: "«",
	raquo: "»",
	lsquo: "‘",
	rsquo: "’",
	ldquo: "“",
	rdquo: "”",
	bull: "•",
	middot: "·",
	deg: "°",
	euro: "€",
	pound: "£",
	yen: "¥",
	cent: "¢",
	copy: "©",
	reg: "®",
	trade: "™"
}, Re = /&(?:#(\d+)|#[xX]([0-9a-fA-F]+)|([a-zA-Z][a-zA-Z0-9]*));/g;
function ze(e) {
	return e.replace(Re, (e, t, n, r) => {
		if (t !== void 0) {
			let n = Number(t);
			return Number.isFinite(n) && n > 0 ? q(n, e) : e;
		}
		if (n !== void 0) {
			let t = parseInt(n, 16);
			return Number.isFinite(t) && t > 0 ? q(t, e) : e;
		}
		return r === void 0 ? e : Le[r.toLowerCase()] ?? e;
	});
}
function q(e, t) {
	try {
		return String.fromCodePoint(e);
	} catch {
		return t;
	}
}
function Be(e) {
	return ze((e.length > K ? e.slice(0, K) : e).replace(Fe, " ").replace(Pe, " ").replace(Ie, "")).replace(/\s+/g, " ").trim();
}
//#endregion
//#region src/api/UpsellingApi.ts
var Ve = "https://www.guruwalk.com", He = class {
	constructor() {
		this.ENDPOINTS = {
			offers: (e = "") => N({
				regular: `api/v3/upselling/offers/?${e}`,
				sdk: `sdk/api/v1/upselling/offers/?${e}`
			}),
			deals: (e = "") => N({
				regular: `api/v3/upselling/deals/?${e}`,
				sdk: `sdk/api/v1/upselling/deals/?${e}`
			}),
			createBulkDeal: () => N({
				regular: "api/v3/upselling/deals/bulk-create/",
				sdk: "sdk/api/v1/upselling/deals/bulk-create/"
			}),
			oneDeal: (e) => N({
				regular: `api/v3/upselling/deals/${e}/`,
				sdk: `sdk/api/v1/upselling/deals/${e}/`
			}),
			oneOffer: (e) => N({
				regular: `api/v3/upselling/offers/${e}/`,
				sdk: `sdk/api/v1/upselling/offers/${e}/`
			}),
			oneOfferBySlug: (e) => N({
				regular: `api/v3/upselling/offers/slug/${e}/`,
				sdk: `sdk/api/v1/upselling/offers/slug/${e}/`
			}),
			thirdPartyDeal: (e) => N({
				regular: `api/v3/upselling/third-party-deals/${e}`,
				sdk: `sdk/api/v1/upselling/third-party-deals/${e}`
			}),
			bulkLock: (e) => N({
				regular: `api/v3/upselling/third-party-deals/bulk-lock/${e}`,
				sdk: `sdk/api/v1/upselling/third-party-deals/bulk-lock/${e}`
			}),
			exists: (e = "") => N({
				regular: `api/v3/upselling/offers/exists/?${e}`,
				sdk: `sdk/api/v1/upselling/offers/exists/?${e}`
			}),
			topOffers: (e) => N({
				regular: `api/v3/upselling/offers/reservations/${e}/top-offers/`,
				sdk: `sdk/api/v1/upselling/offers/reservations/${e}/top-offers/`
			}),
			esimPackages: (e = "") => N({
				regular: `api/v3/upselling/airalo/packages/?${e}`,
				sdk: `sdk/api/v1/upselling/airalo/packages/?${e}`
			}),
			createEsimOrder: () => N({
				regular: "api/v3/upselling/airalo/orders/",
				sdk: "sdk/api/v1/upselling/airalo/orders/"
			}),
			esims: (e = "") => N({
				regular: `api/v3/upselling/airalo/sims/?${e}`,
				sdk: `sdk/api/v1/upselling/airalo/sims/?${e}`
			}),
			esimInstructions: (e) => N({
				regular: `api/v3/upselling/airalo/sims/${e}`,
				sdk: `sdk/api/v1/upselling/airalo/sims/${e}`
			}),
			upsellingAiraloFeature: () => N({
				regular: "api/v3/upselling/airalo/feature/",
				sdk: "sdk/api/v1/upselling/airalo/feature/"
			}),
			getCompatibleDevices: (e = "") => N({
				regular: `api/v3/upselling/airalo/devices/?${e}`,
				sdk: `sdk/api/v1/upselling/airalo/devices/?${e}`
			}),
			radicalStorageNearby: () => N({
				regular: "api/v3/upselling/radical-storage/storages/nearby/",
				sdk: "sdk/api/v1/upselling/radical-storage/storages/nearby/"
			})
		};
	}
	async getRadicalStorageNearby(e, t) {
		return (await A.post(this.ENDPOINTS.radicalStorageNearby(), {
			json: e,
			...t
		})).body.storages.map((e) => ({
			...e,
			description: e.description ? Be(e.description) : ""
		}));
	}
	async getCompatibleDevices(e = "", t) {
		return (await A.get(this.ENDPOINTS.getCompatibleDevices(e), t)).body;
	}
	async getUpsellingEsimFeature(e) {
		return (await A.get(this.ENDPOINTS.upsellingAiraloFeature(), e)).body;
	}
	async getEsimPackages(e, t = "", n) {
		return (await A.post(this.ENDPOINTS.esimPackages(t), {
			json: e,
			...n
		})).body;
	}
	async getEsims(e = "", t) {
		return (await A.get(this.ENDPOINTS.esims(e), t)).body;
	}
	async getEsimInstructions(e, t) {
		return (await A.get(this.ENDPOINTS.esimInstructions(e), t)).body;
	}
	async createEsimOrder(e, t) {
		return (await A.post(this.ENDPOINTS.createEsimOrder(), {
			json: e,
			...t
		})).body;
	}
	async getOffers(e = "", t) {
		return (await A.get(this.ENDPOINTS.offers(e), t)).body;
	}
	async getOffer(e, t) {
		return (await A.get(this.ENDPOINTS.oneOffer(e), t)).body;
	}
	async getOfferBySlug(e, t) {
		return (await A.get(this.ENDPOINTS.oneOfferBySlug(e), t)).body;
	}
	async getTopOffers(e, t) {
		return (await A.get(this.ENDPOINTS.topOffers(e), t)).body;
	}
	async getDeals(e = "", t) {
		return (await A.get(this.ENDPOINTS.deals(e), t)).body;
	}
	async deleteDeal(e, t) {
		return (await A.delete(this.ENDPOINTS.oneDeal(e), t)).body;
	}
	async createBulkDeal(e, t) {
		return (await A.post(this.ENDPOINTS.createBulkDeal(), {
			json: e,
			...t
		})).body;
	}
	async createOrUpdateThirdPartyDeal(e, t) {
		return (await A[e?.deal_id ? "patch" : "post"](this.ENDPOINTS.thirdPartyDeal(e?.deal_id ?? ""), {
			json: e,
			...t
		})).body;
	}
	async createOrUpdateBuildLock(e, t) {
		return (await A[e?.bulk_lock_id ? "patch" : "post"](this.ENDPOINTS.bulkLock(e?.bulk_lock_id ?? ""), {
			json: e,
			...t
		})).body;
	}
	async fetchCheckIfOffersExists(e = "", t) {
		return (await A.get(this.ENDPOINTS.exists(e), t)).body;
	}
	async getGuruWalkTours({ locality: e, language: t, limit: n, country: r, checkIn: i, checkOut: a }) {
		let o = new URL("/api/v2/tours", Ve);
		o.searchParams.set("locality", e), o.searchParams.set("lang", t), o.searchParams.set("country", r), o.searchParams.set("from", i), o.searchParams.set("to", a), o.searchParams.set("api_key", "1wCMGgErWUxqVGDNjPX1cw"), n && o.searchParams.set("limit", String(n));
		let s = await fetch(o.toString());
		if (!s.ok) throw Error("Failed to fetch GuruWalk tours");
		let c = await s.json();
		return (Array.isArray(c?.objects) ? c.objects : []).map((e) => ({
			id: String(e.id),
			title: e.title,
			description: Be(e.description),
			url: e.url,
			imageUrl: e.image?.original,
			ratingAverage: e.ratingAverage ? parseFloat(e.ratingAverage) : void 0,
			testimonialsCount: e.testimonialsCount
		}));
	}
}, Ue = class {
	constructor() {
		this.ENDPOINTS = {
			getPropertyProtectionsByReservation: (e) => N({
				regular: `api/v3/insurance/property-protection-for-reservation/${e}/`,
				sdk: `sdk/api/v1/insurance/property-protection-for-reservation/${e}/`
			}),
			insuranceSetup: (e = "") => N({
				regular: `api/v4/insurance-setup/${e ? e + "/" : ""}`,
				sdk: `sdk/api/v2/insurance-setup/${e ? e + "/" : ""}`
			})
		};
	}
	async getPropertyProtectionsByReservation(e, t) {
		return (await A.get(this.ENDPOINTS.getPropertyProtectionsByReservation(e), t)).body;
	}
	async mutateInsuranceSetup({ id: e, ...t }, n) {
		return (await A[e ? "patch" : "post"](this.ENDPOINTS.insuranceSetup(e), {
			json: t,
			...n
		})).body;
	}
	async getInsuranceSetup(e, t) {
		return (await A.get(this.ENDPOINTS.insuranceSetup(e), t)).body;
	}
}, We = class {
	constructor() {
		this.ENDPOINTS = {
			unlock: (e = "") => N({
				regular: `api/v3/locks/unlock/?${e}`,
				sdk: `sdk/api/v1/locks/unlock/?${e}`
			}),
			getLocks: (e = "") => N({
				regular: `api/v4/guestapp/locks/?${e}`,
				sdk: `sdk/api/v1/guestapp/locks/?${e}`
			}),
			getLockConditions: (e = "") => N({
				regular: `api/v4/guestapp/reservation-conditions/?${e}`,
				sdk: `sdk/api/v1/guestapp/reservation-conditions/?${e}`
			}),
			locksRooms: (e) => `api/v3/locks/${e}/get-external-locks/`
		};
	}
	async getLocks(e = "", t) {
		return (await A.get(this.ENDPOINTS.getLocks(e), {
			requireEncryption: !0,
			...t
		})).body.results?.[0]?.unlock_links ?? [];
	}
	async getLockConditions(e = "", t) {
		return (await A.get(this.ENDPOINTS.getLockConditions(e), t)).body;
	}
	async unlock(e = "", t) {
		return (await A.get(this.ENDPOINTS.unlock(e), t)).body;
	}
	async getLocksRooms(e, t) {
		return (await A.get(this.ENDPOINTS.locksRooms(e), t)).body;
	}
}, Ge = class {
	constructor() {
		this.ENDPOINTS = { getCustomTheme: (e = "") => N({
			regular: `api/v4/branding/templates/${e}/`,
			sdk: `sdk/api/v1/branding/templates/${e}/`
		}) };
	}
	async getCustomTheme(e, t) {
		return (await A.get(this.ENDPOINTS.getCustomTheme(e), t)).body;
	}
}, Ke = class {
	constructor() {
		this.ENDPOINTS = {
			all: (e) => `api/v3/documents-v2/guidebooks/reservations/${e}/`,
			guidebook: (e, t) => `api/v3/documents-v2/guidebooks/${e}/reservations/${t}/`,
			group: (e) => `api/v3/documents-v2/guidebook-groups/${e}/guidebooks/`,
			byHousing: (e) => `api/v3/documents-v2/guidebook-groups/housings/${e}/?is_active=true`
		};
	}
	async getGuidebooks(e, t) {
		return (await A.get(this.ENDPOINTS.all(e), t)).body;
	}
	async getGuidebook(e, t, n) {
		return (await A.get(this.ENDPOINTS.guidebook(e, t), n)).body;
	}
	async getGuidebooksByHousing(e, t) {
		return (await A.get(this.ENDPOINTS.byHousing(e), t)).body;
	}
	async getGuidebooksByGroup(e, t) {
		return (await A.get(this.ENDPOINTS.group(e), t)).body;
	}
}, qe = /* @__PURE__ */ function(e) {
	return e.Unknown = "UNKNOWN", e.Guest = "GUEST", e.Host = "HOST", e;
}(qe || {});
function J(e) {
	return {
		user_type: "GUEST",
		...e
	};
}
var Je = class {
	constructor() {
		this.ENDPOINTS = {
			createFeedback: () => "api/v3/feedbacks/",
			feedback: (e) => `api/v3/feedbacks/${e}/`,
			checkoutFeedback: () => "api/v3/reservation-check-out-feedbacks/"
		};
	}
	async getFeedback(e, t) {
		let n = new URLSearchParams({ reservation_id: e });
		return (await A.get(`${this.ENDPOINTS.createFeedback()}?${n.toString()}`, t)).body;
	}
	async createFeedback(e, t) {
		return (await A.post(this.ENDPOINTS.createFeedback(), {
			json: J(e),
			...t
		})).body;
	}
	async updateFeedback(e, t, n) {
		return (await A.patch(this.ENDPOINTS.feedback(e), {
			json: J(t),
			...n
		})).body;
	}
	async saveFeedback(e, t) {
		let n = (await this.getFeedback(e.reservation, t).catch(() => void 0))?.[0];
		return n?.id ? this.updateFeedback(n.id, e, t) : this.createFeedback(e, t);
	}
	async getCheckoutFeedback(e, t) {
		let n = new URLSearchParams({ reservation: e }).toString();
		return (await A.get(`${this.ENDPOINTS.checkoutFeedback()}?${n}`, t)).body;
	}
	async createCheckoutFeedback(e, t) {
		return (await A.post(this.ENDPOINTS.checkoutFeedback(), {
			json: J(e),
			...t
		})).body;
	}
}, Ye = {
	email: "email",
	phone: "phone_number"
}, Xe = {
	contactVerification: "contact_verification",
	guestappChat: "guestapp_chat"
}, Ze = class {
	constructor() {
		this.ENDPOINTS = {
			generate: () => "api/v1/verification/generate/",
			verify: () => "api/v1/verification/verify/",
			settings: (e) => `api/v1/verification/settings?housing=${e}`
		};
	}
	async generate(e, t) {
		return (await A.post(this.ENDPOINTS.generate(), {
			json: e,
			credentials: "include",
			...t
		})).body;
	}
	async verify(e, t) {
		return (await A.post(this.ENDPOINTS.verify(), {
			json: e,
			credentials: "include",
			...t
		})).body;
	}
	async getSettings(e, t) {
		return (await A.get(this.ENDPOINTS.settings(e), t)).body;
	}
}, Y = class {
	constructor() {
		this.ENDPOINTS = { printedCards: (e = "") => `api/v4/guestapp/reservations/${e}/printed-cards/` };
	}
	async getPrintedCards(e, t) {
		return (await A.get(this.ENDPOINTS.printedCards(e), t)).body;
	}
	async addPrintedCard(e, t) {
		return (await A.post(this.ENDPOINTS.printedCards(e), t)).body;
	}
};
//#endregion
//#region src/api/CommunicationsApi.ts
function Qe() {
	return E;
}
var X = Qe(), $e = {
	media: "MEDIA",
	attachments: "ATTACHMENTS"
}, et = class {
	constructor() {
		this.ENDPOINTS = {
			getChatRoomByReservation: (e) => `${X}/api/v1/communication/chats/rooms/${e}`,
			chatMessages: (e) => `${X}/api/v1/communication/chats/guestapp/rooms/${e}/messages`,
			createChatRoom: () => `${X}/api/v1/communication/chats/rooms`,
			guestAppSettings: () => `${X}/api/v1/communication/chats/guestapp/settings`,
			userPreferences: () => `${X}/api/v1/communication/user-preferences`,
			attachments: (e) => `${X}/api/v1/communication/chats/guestapp/rooms/${e}/attachments`
		};
	}
	async getChatRoomByReservation(e, t) {
		try {
			let n = new URL(this.ENDPOINTS.getChatRoomByReservation(e));
			return n.searchParams.set("reservation_id", e), (await A.get("", {
				externalURL: n.toString(),
				credentials: "include",
				...t
			})).body;
		} catch (e) {
			if ((e?.status ?? e?.response?.status) === 404) return null;
			throw e;
		}
	}
	async getChatMessages(e, t, n) {
		let r = new URL(this.ENDPOINTS.chatMessages(e));
		return r.searchParams.set("reservation_id", t), (await A.get("", {
			externalURL: r.toString(),
			credentials: "include",
			...n
		})).body;
	}
	async uploadAttachment(e, t, n, r) {
		let i = new URL(this.ENDPOINTS.attachments(e));
		i.searchParams.set("reservation_id", t);
		let a = new FormData();
		return a.append("attachment", n), (await A.post("", {
			externalURL: i.toString(),
			body: a,
			headers: {},
			credentials: "include",
			...r
		})).body;
	}
	async getGuestAppSettings(e) {
		try {
			return (await A.get("", {
				externalURL: this.ENDPOINTS.guestAppSettings(),
				...e
			})).body;
		} catch (e) {
			if ((e?.status ?? e?.response?.status) === 404) return null;
			throw e;
		}
	}
	async getUserPreferences(e) {
		try {
			return (await A.get("", {
				externalURL: this.ENDPOINTS.userPreferences(),
				...e
			})).body;
		} catch (e) {
			if ((e?.status ?? e?.response?.status) === 404) return null;
			throw e;
		}
	}
	async createChatRoom(e, t) {
		return (await A.post("", {
			externalURL: this.ENDPOINTS.createChatRoom(),
			json: { reservation_info: e },
			credentials: "include",
			...t
		})).body;
	}
}, tt = class {
	constructor() {
		this.locationApi = new R();
	}
	getAllCountries(e) {
		return this.locationApi.fetchAllCountries(e);
	}
	getHousingLocation(e, t) {
		return this.locationApi.getByHousingId(e, t);
	}
	transformPaginatedListToOptions(e, t) {
		return e.then((e) => ({
			...e,
			results: t(e)
		}));
	}
	getCountriesList(e) {
		let t = this.locationApi.fetchCountriesList(e);
		return this.transformPaginatedListToOptions(t, _.getCountriesAsOptions);
	}
	getProvincesList(e) {
		let t = this.locationApi.fetchProvincesList(e);
		return this.transformPaginatedListToOptions(t, _.getProvincesAsOptions);
	}
	getCitiesList(e) {
		let t = this.locationApi.fetchCitiesList(e);
		return this.transformPaginatedListToOptions(t, _.getCitiesAsOptions);
	}
	getDistrictsList(e) {
		let t = this.locationApi.fetchDistrictsList(e);
		return this.transformPaginatedListToOptions(t, _.getDistrictsAsOptions);
	}
	getMunicipalitiesList(e) {
		let t = this.locationApi.fetchMunicipalitiesList(e);
		return this.transformPaginatedListToOptions(t, _.getProvincesAsOptions);
	}
	getSpanishResidenceCitiesList(e, t) {
		let n = this.locationApi.fetchSpanishResidenceCitiesList(e, t);
		return this.transformPaginatedListToOptions(n, _.getSpanishCitiesAsOptions);
	}
	getLocationsByExternalUrl(e, t) {
		let n = this.locationApi.fetchLocationsByExternalUrl(e, t);
		return this.transformPaginatedListToOptions(n, _.getSpanishCitiesAsOptions);
	}
};
//#endregion
//#region src/utils/utils.ts
function nt(e) {
	throw Error(e);
}
//#endregion
//#region ../../node_modules/debounce-promise/dist/index.js
var rt = /* @__PURE__ */ te(((e, t) => {
	t.exports = function(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = void 0, o = void 0, s = void 0, c = [];
		return function() {
			var u = n(t), d = (/* @__PURE__ */ new Date()).getTime(), ee = !a || d - a > u;
			a = d;
			var f = [...arguments];
			if (ee && i.leading) return i.accumulate ? Promise.resolve(e.call(this, [f])).then(function(e) {
				return e[0];
			}) : Promise.resolve(e.call.apply(e, [this].concat(f)));
			if (o ? clearTimeout(s) : o = r(), c.push(f), s = setTimeout(l.bind(this), u), i.accumulate) {
				var p = c.length - 1;
				return o.promise.then(function(e) {
					return e[p];
				});
			}
			return o.promise;
		};
		function l() {
			var t = o;
			clearTimeout(s), Promise.resolve(i.accumulate ? e.call(this, c) : e.apply(this, c[c.length - 1])).then(t.resolve, t.reject), c = [], o = null;
		}
	};
	function n(e) {
		return typeof e == "function" ? e() : e;
	}
	function r() {
		var e = {};
		return e.promise = new Promise(function(t, n) {
			e.resolve = t, e.reject = n;
		}), e;
	}
}));
//#endregion
//#region ../../node_modules/awesome-imperative-promise/dist/index.es.js
function it(e) {
	var t = null, n = null, r = new Promise(function(e, r) {
		t = e, n = r;
	});
	return e && e.then(function(e) {
		t && t(e);
	}, function(e) {
		n && n(e);
	}), {
		promise: r,
		resolve: function(e) {
			t && t(e);
		},
		reject: function(e) {
			n && n(e);
		},
		cancel: function() {
			t = null, n = null;
		}
	};
}
//#endregion
//#region ../../node_modules/awesome-only-resolves-last-promise/dist/index.es.js
function at(e) {
	var t = null;
	return function() {
		var n = [...arguments];
		t && t();
		var r = it(e.apply(void 0, n)), i = r.promise;
		return t = r.cancel, i;
	};
}
//#endregion
//#region ../../node_modules/awesome-debounce-promise/dist/index.es.js
var ot = /* @__PURE__ */ re(rt()), Z = function() {
	return Z = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Z.apply(this, arguments);
}, st = {
	key: function() {
		return null;
	},
	onlyResolvesLast: !0
}, ct = function() {
	function e(e) {
		this.config = e, this.debounceSingleton = null, this.debounceCache = {};
	}
	return e.prototype._createDebouncedFunction = function() {
		var e = (0, ot.default)(this.config.func, this.config.wait, this.config.options);
		return this.config.options.onlyResolvesLast && (e = at(e)), { func: e };
	}, e.prototype.getDebouncedFunction = function(e) {
		var t, n = (t = this.config.options).key.apply(t, e);
		return n == null ? (this.debounceSingleton ||= this._createDebouncedFunction(), this.debounceSingleton) : (this.debounceCache[n] || (this.debounceCache[n] = this._createDebouncedFunction()), this.debounceCache[n]);
	}, e;
}();
function lt(e, t, n) {
	var r = new ct({
		func: e,
		wait: t,
		options: Z({}, st, n)
	});
	return (function() {
		var e = [...arguments];
		return r.getDebouncedFunction(e).func.apply(void 0, e);
	});
}
//#endregion
//#region src/utils/validators.ts
var ut = 500, dt = async (e) => {
	try {
		return !e || !e.trim() || await new F().validatePhoneNumber({ phone: e }, { errorRetryLimit: 0 }), !0;
	} catch {
		return "invalid_phone_number";
	}
}, Q = {}, ft = lt(async (e) => {
	let t = await dt(e);
	return Q[e] = t, typeof t == "string" ? r.t(t) : t;
}, ut), pt = { phoneValidateService: (e) => {
	let t = c(e);
	if (t && t.trim()) {
		if (Q[t]) {
			let e = Q[t];
			return typeof e == "string" ? r.t(e) : e;
		}
		return ft(t);
	}
} }, $ = /* @__PURE__ */ function(e) {
	return e.id = "id", e.reservation_id = "reservation_id", e.name = "name", e.surname = "surname", e.second_surname = "second_surname", e.birth_date = "birth_date", e.gender = "gender", e.nationality = "nationality", e.citizenship = "citizenship", e.document_type = "document_type", e.document_number = "document_number", e.document_issue_date = "document_issue_date", e.document_expiration_date = "document_expiration_date", e.document_expedition_country = "document_expedition_country", e.document_expedition_city = "document_expedition_city", e.document_expedition_municipality = "document_expedition_municipality", e.visa_number = "visa_number", e.purpose_of_stay = "purpose_of_stay", e.tax_exemption = "tax_exemption", e.full_tourist_tax = "full_tourist_tax", e.birth_place_country = "birth_place_country", e.birth_place_city = "birth_place_city", e.birth_place_municipality = "birth_place_municipality", e.birth_place_address = "birth_place_address", e.residence_country = "residence_country", e.residence_city = "residence_city", e.residence_community = "residence_community", e.residence_municipality = "residence_municipality", e.residence_province = "residence_province", e.residence_address = "residence_address", e.residence_street = "residence_street", e.residence_house_number = "residence_house_number", e.residence_postal_code = "residence_postal_code", e.arrived_from_country = "arrived_from_country", e.arrived_from_district = "arrived_from_district", e.arrived_from_municipality = "arrived_from_municipality", e.arrived_from_province = "arrived_from_province", e.next_destination_country = "next_destination_country", e.next_destination_district = "next_destination_district", e.next_destination_province = "next_destination_province", e.next_destination_address = "next_destination_address", e.next_destination_municipality = "next_destination_municipality", e.fiscal_code = "fiscal_code", e.email = "email", e.phone = "phone", e.second_phone = "second_phone", e.document_front_side_scan = "document_front_side_scan", e.document_back_side_scan = "document_back_side_scan", e.biomatch_doc = "biomatch_doc", e.biomatch_passed = "biomatch_passed", e.biomatch_selfie = "biomatch_selfie", e.ocr_passed = "ocr_passed", e.signature = "signature", e.biomatch_doc_id = "biomatch_doc_id", e.document_support_number = "document_support_number", e.kinship_relationship = "kinship_relationship", e.is_leader = "is_leader", e.external_category_id = "external_category_id", e.external_documents_biomatch_doc = "external_documents_biomatch_doc", e.external_documents_biomatch_doc_service = "external_documents_biomatch_doc_service", e.external_documents_biomatch_selfie = "external_documents_biomatch_selfie", e.external_documents_biomatch_selfie_service = "external_documents_biomatch_selfie_service", e.external_documents_front_side_scan = "external_documents_front_side_scan", e.external_documents_front_side_scan_service = "external_documents_front_side_scan_service", e.external_documents_back_side_scan = "external_documents_back_side_scan", e.external_documents_back_side_scan_service = "external_documents_back_side_scan_service", e.is_iv_failed = "is_iv_failed", e.is_iv_skipped = "is_iv_skipped", e.is_under_16_iv_bypass_declared = "is_under_16_iv_bypass_declared", e.liveness_video_link = "liveness_video_link", e.participant_id = "participant_id", e.force_show_leaders_fields = "force_show_leaders_fields", e.invoice_leader_type = "invoice_leader_type", e.recipient_code_type = "recipient_code_type", e.vat_number = "vat_number", e.recipient_code = "recipient_code", e.chip_card = "chip_card", e.mode_of_transport = "mode_of_transport", e.mother_name = "mother_name", e.mother_surname = "mother_surname", e.birth_name = "birth_name", e.birth_surname = "birth_surname", e.country_place_of_entry = "country_place_of_entry", e.country_date_of_entry = "country_date_of_entry", e.legal_company_name = "legal_company_name", e;
}($ || {}), mt = class {
	constructor() {
		this.algorithm = "AES-GCM", this.keyLength = 256;
	}
	async deriveKey(e, t, n = "api-response-encryption") {
		let r = new TextEncoder(), i = await crypto.subtle.importKey("raw", r.encode(e), "HKDF", !1, ["deriveKey"]), a = r.encode(t), o = r.encode(n);
		return await crypto.subtle.deriveKey({
			name: "HKDF",
			hash: "SHA-256",
			salt: a,
			info: o
		}, i, {
			name: this.algorithm,
			length: this.keyLength
		}, !1, ["decrypt"]);
	}
	async decrypt(e, t) {
		let n = this.base64ToArrayBuffer(e?.data), r = this.base64ToArrayBuffer(e?.nonce), i = await crypto.subtle.decrypt({
			name: this.algorithm,
			iv: r
		}, t, n), a = new TextDecoder().decode(i);
		return JSON.parse(a);
	}
	base64ToArrayBuffer(e) {
		let t = atob(e), n = new Uint8Array(t.length);
		for (let e = 0; e < t.length; e++) n[e] = t.charCodeAt(e);
		return n.buffer;
	}
}, ht = class {
	constructor(e) {
		this.decryption = new mt(), this.decryptionKey = null, this.config = {
			masterKey: e.masterKey,
			salt: e.salt,
			info: e.info || "api-response-encryption",
			jwtToken: e.jwtToken || void 0,
			...e
		};
	}
	async initialize() {
		if (!this.config.enabled) return null;
		if (!this.config.masterKey) throw Error("Decryption requires masterKey (should match ENCRYPTION_MASTER_KEY setting)");
		if (!this.config.salt) throw Error("Decryption requires salt (should match ENCRYPTION_SALT setting)");
		let e = this.config.jwtToken || this.config.info, t = await this.decryption.deriveKey(this.config.masterKey, this.config.salt, e);
		return this.decryptionKey = t, t;
	}
	setJwtToken(e) {
		this.config.jwtToken = e, this.decryptionKey = null;
	}
	getEncryptionHeaders() {
		return this.config.enabled ? { "X-Session-Type": "basic" } : {};
	}
	isResponseEncrypted(e) {
		return e.headers.get("X-Encrypted") === "true";
	}
	async decryptResponse(e, t) {
		let n = t || this.decryptionKey;
		return n ||= await this.initialize(), await this.decryption.decrypt(e, n);
	}
	async getDecryptionKey() {
		return this.decryptionKey || await this.initialize(), this.decryptionKey;
	}
	isEnabled() {
		return this.config.enabled;
	}
}, gt = 1, _t = { noAccess: "no_access" };
function vt(e) {
	let t = e.split(".")[gt], { user_id: n } = JSON.parse(atob(t));
	return n;
}
var yt = () => {
	try {
		let e = S.getToken();
		if (e === null) return null;
		let t = e.split(".")[gt], { inbox_access: n } = JSON.parse(atob(t));
		return n ?? null;
	} catch (e) {
		return console.error(e), null;
	}
}, bt = () => {
	let e = yt();
	return e === null || e === _t.noAccess;
}, xt = () => {
	try {
		let e = S.getToken();
		return e === null ? null : vt(e) ?? null;
	} catch {
		return null;
	}
}, St = () => {
	try {
		let e = S.getToken();
		if (e !== null) return vt(e);
	} catch (e) {
		console.error(e);
	}
	throw Error("Failed to get user id");
};
//#endregion
//#region src/services/AuthService.ts
function Ct(e) {
	return !!e?.instance_id;
}
var wt = (e) => {
	let [t, n] = e?.build_hash?.split(".") || [];
	return {
		masterKey: t,
		salt: n
	};
}, Tt = class {
	constructor(e) {
		this.authApi = new j(), this.configureDecryptionCallback = e;
	}
	async init(e, t) {
		let n = await this.authApi.getAuthToken(De(e), t);
		if (e.encryptionEnabled && this.configureDecryptionCallback) {
			let { masterKey: e, salt: t } = wt(n);
			e && t && await this.configureDecryptionCallback({
				enabled: !0,
				masterKey: e,
				salt: t,
				jwtToken: n.access_token
			}).catch((e) => {
				console.error("Failed to configure decryption:", e);
			});
		}
		return n.access_token && S.persistToken(n.access_token), n;
	}
	async initChekin(e, t) {
		let { body: n, headers: r } = await this.authApi.getChekinToken({ token: e }, t), i = r.get("Authorization");
		return n && S.persistToken(Ct(n) ? i : n.user), n;
	}
	async checkEmail(e, t) {
		return this.authApi.checkEmail(e, t);
	}
	async initiateUser(e, t) {
		return this.authApi.initiateUser(e, t);
	}
	async finalizeUser(e, t) {
		return this.authApi.finalizeUser(e, t);
	}
	async getGuestAccountToken(e, t) {
		return this.authApi.getToken(e, t);
	}
	async getMe(e) {
		return this.authApi.getMe(e);
	}
	async getParticipants(e) {
		return this.authApi.getParticipants(e);
	}
	async oauthGoogleCallback(e, t) {
		return this.authApi.oauthGoogleCallback(e, t);
	}
}, Et = "7qqmrt6doh.execute-api.eu-central-1.amazonaws.com/stg", Dt = "api-ng.chekintest.xyz/api/v1/liveness-detection/ws/detect-position", Ot = "localhost:8765", kt = class {
	connectWebSocket() {
		let e = `wss://${Et}/?token=${S.getToken()}`;
		return new WebSocket(e);
	}
	connectLivenessWebSocket() {
		return new WebSocket(`wss://${Dt}`);
	}
	connectDocumentDetectionWebSocket() {
		let e = `wss://${Dt.replace("detect-position", "detect-document")}`;
		return new WebSocket(e);
	}
	connectKioskoWebSocket() {
		return new WebSocket(`ws://${Ot}`);
	}
}, At = class {
	constructor() {
		this.aiApi = new M();
	}
	async getGuide(e, t) {
		if (!e) throw Error("The reservation id argument is not found");
		return await this.aiApi.getGuide(e, t);
	}
	async generateGuide(e, t) {
		if (!e.reservation_id) throw Error("The reservation id argument is not found");
		return await this.aiApi.generateGuide(e, t);
	}
	async retryGuide(e, t) {
		if (!e) throw Error("The reservation id argument is not found");
		return await this.aiApi.retryGuide(e, t);
	}
	async getGuideRun(e, t) {
		if (!e) throw Error("The run id argument is not found");
		return await this.aiApi.getGuideRun(e, t);
	}
	async getTravelGuideThumbnail(e, t) {
		if (!e) throw Error("The country code argument is not found");
		return await this.aiApi.getTravelGuideThumbnail(e, t);
	}
	async dismissSlot(e, t, n) {
		if (!e) throw Error("The reservation id argument is not found");
		if (!t) throw Error("The slot id argument is not found");
		return await this.aiApi.dismissSlot(e, t, n);
	}
}, jt = class {
	constructor() {
		this.guestApi = new P();
	}
	getFileName(e, t) {
		return `${e}-${$[e]}.${t[e]?.type}`;
	}
	transformPayloadToFormData(e) {
		let t = new FormData();
		for (let n in e) {
			let r = n, i = e?.[r], a = r === $.signature && !i;
			if (r === "iv_overrides") {
				e.iv_overrides !== void 0 && t.set(r, JSON.stringify(e.iv_overrides));
				continue;
			}
			if (i || i === !1) {
				let n = i.toString() || "";
				l(i) ? t.append(r, i, this.getFileName(r, e)) : t.set(r, n);
			}
			a && t.set(r, "");
		}
		return t;
	}
	async getOne(e) {
		return this.guestApi.getOne(e);
	}
	async createOrUpdate({ data: { id: e, ...t } }, n, r) {
		if (!t) throw Error("The payload or reservation id is missing");
		let i = this.transformPayloadToFormData(t);
		return e ? n ? await this.guestApi.patch(e, i, r) : await this.guestApi.put(e, i, r) : await this.guestApi.create(i, r);
	}
	createWithMinData(e, t) {
		return this.guestApi.createMin(e, t);
	}
	createGuestByParticipant(e, t) {
		return this.guestApi.createGuestByParticipant(e, t);
	}
	async delete(e, t) {
		if (!e) throw Error("The guest id argument is not found");
		return await this.guestApi.delete(e, t);
	}
	async getSchema(e, t) {
		if (!e?.reservation_id) throw Error("The reservation id argument is not found");
		return await this.guestApi.getSchema(e, t);
	}
	async getDocumentChoices(e, t) {
		return await this.guestApi.getDocumentChoices(e, t);
	}
	async uploadLivenessVideo(e, t) {
		return await this.guestApi.uploadLivenessVideo(e, t);
	}
	async livenessDetection(e, t) {
		return await this.guestApi.livenessDetection(e, t);
	}
	async searchForIV(e, t) {
		return await this.guestApi.searchForIV(e, t);
	}
}, Mt = class e {
	static get initParams() {
		return g.initParams;
	}
	static set initParams(e) {
		g.setInitParams(e);
	}
	static get sdkVersion() {
		return g.sdkVersion;
	}
	static set sdkVersion(e) {
		g.sdkVersion = e;
	}
	static get isSDK() {
		return g.isSDK;
	}
	static #e = this._auth = new Tt(e.configureDecryption);
	static get auth() {
		return {
			init: e._auth.init.bind(e._auth),
			initChekin: e._auth.initChekin.bind(e._auth),
			checkEmail: e._auth.checkEmail.bind(e._auth),
			initiateUser: e._auth.initiateUser.bind(e._auth),
			finalizeUser: e._auth.finalizeUser.bind(e._auth),
			getGuestAccountToken: e._auth.getGuestAccountToken.bind(e._auth),
			getMe: e._auth.getMe.bind(e._auth),
			getParticipants: e._auth.getParticipants.bind(e._auth),
			oauthGoogleCallback: e._auth.oauthGoogleCallback.bind(e._auth)
		};
	}
	static #t = this.communications = new et();
	static #n = this.validations = new F();
	static #r = this.locations = new tt();
	static #i = this.identityVerification = new z();
	static #a = this.taxes = new B();
	static #o = this.guestFormAdditionalData = new V();
	static #s = this.documents = new U();
	static #c = this.guestGroup = new W();
	static #l = this.payments = new G();
	static #u = this.webSocket = new kt();
	static #d = this.guest = new jt();
	static #f = this.reservation = new L();
	static #p = this.housing = new H();
	static #m = this.upselling = new He();
	static #h = this.feedback = new Je();
	static #g = this.verification = new Ze();
	static #_ = this.propertyProtection = new Ue();
	static #v = this.locks = new We();
	static #y = this.kiosko = new Y();
	static #b = this.theme = new Ge();
	static #x = this.guidebooks = new Ke();
	static #S = this.ai = new At();
	static async initSDK(t) {
		if (!t.apikey) throw Error("Chekin API key not found or not valid");
		g.setInitParams(t), g.setIsSDK(!0);
		let n = await e._auth.init(t);
		return n.access_token && g.setJwtToken(n.access_token), n;
	}
	static async init(t) {
		return g.setIsSDK(!1), e._auth.initChekin(t);
	}
	static async configureDecryption(e) {
		let t = new ht(e);
		e.enabled && await t.initialize(), h.setDecryptionManager(t);
	}
	static setJwtToken(e) {
		g.setJwtToken(e);
	}
	static isDecryptionEnabled() {
		return h.isDecryptionEnabled();
	}
}, Nt = /* @__PURE__ */ function(e) {
	return e.Morning = "morning", e.Afternoon = "afternoon", e.Evening = "evening", e.Flex = "flex", e;
}({}), Pt = /* @__PURE__ */ function(e) {
	return e.RESERVATION_ONLY = "RESERVATION_ONLY", e.ASK_PREFERENCES = "ASK_PREFERENCES", e;
}({}), Ft = /* @__PURE__ */ function(e) {
	return e.Free = "free", e.Low = "low", e.Medium = "medium", e.High = "high", e.Unknown = "unknown", e;
}({}), It = /* @__PURE__ */ function(e) {
	return e.WebSearch = "web_search", e.UpsellingOffer = "upsell_offer", e.Esim = "airalo", e.Guruwalk = "guruwalk", e.ReservationContext = "reservation_context", e;
}({}), Lt = /* @__PURE__ */ function(e) {
	return e.START = "START", e.EXPLORE = "EXPLORE", e.AWAIT_PREFERENCES = "AWAIT_PREFERENCES", e.BUILD_PROFILE = "BUILD_PROFILE", e.DISCOVER_CONTENT = "DISCOVER_CONTENT", e.BUILD_GUIDE = "BUILD_GUIDE", e.DONE = "DONE", e.FAILED = "FAILED", e.CANCELLED = "CANCELLED", e;
}({});
//#endregion
export { Mt as API, M as AiApi, j as AuthApi, $e as CHAT_MEDIA_DISPLAY_VARIANT, ge as CORS_ERRORS, et as CommunicationsApi, y as DecryptionError, ht as DecryptionManager, U as DocumentsApi, v as ERROR_CODES, _e as ERR_INTERNET_DISCONNECTED_MESSAGE, Je as FeedbackApi, qe as FeedbackUserType, le as GUEST_TOKEN_STORAGE_KEY, P as GuestApi, V as GuestFormAdditionalDataApi, W as GuestGroupApi, C as GuestTokenStorageHandler, Ke as GuidebooksApi, H as HousingApi, i as IVStatus, z as IdentityVerificationApi, Y as KioskoApi, x as LS_I18NEXT_LNG_KEY, R as LocationApi, We as LocksApi, ue as MAX_RETRIES_REQUESTS_NUMBER, S as MainTokenStorageHandler, $ as PAYLOAD_FIELDS_NAMES, G as PaymentsApi, Ue as PropertyProtectionApi, ye as RETRY_ERROR_CODES, L as ReservationApi, b as TOKEN_STORAGE_KEY, B as TaxesApi, Ge as ThemeApi, Ft as TravelGuideCostBand, Pt as TravelGuideMode, Lt as TravelGuideNode, It as TravelGuideSourceType, Nt as TravelGuideTimeOfDay, He as UpsellingApi, Ye as VERIFICATION_METHODS, Xe as VERIFICATION_PURPOSES, F as ValidatorApi, pt as Validators, Ze as VerificationApi, de as WS_EVENT_TYPES, A as apiClient, T as buildRequestHeaders, nt as displayError, yt as getInboxAccessFromMainToken, D as getURL, St as getUserIdFromToken, bt as isInboxAccessDenied, xt as tryGetUserIdFromToken };

//# sourceMappingURL=index.js.map